"use client";

import { cn } from "../../lib/utils";

export function getLeaderboardInitials(name: string | undefined | null): string {
  const normalized = name?.trim();

  if (!normalized) return "?";

  const words = normalized.split(/\s+/).filter(Boolean);
  if (words.length === 1) {
    return Array.from(words[0] ?? "")
      .slice(0, 1)
      .join("")
      .toUpperCase();
  }

  return words
    .slice(0, 2)
    .map((word) => Array.from(word)[0] ?? "")
    .join("")
    .toUpperCase();
}

interface LeaderboardDisplayNameProps {
  name: string;
  isAnonymous?: boolean;
  className?: string;
  anonymousLabel?: string;
}

export function LeaderboardDisplayName({
  name,
  isAnonymous = false,
  className,
  anonymousLabel = "Anonymous creator",
}: LeaderboardDisplayNameProps) {
  if (!isAnonymous) {
    return <p className={className}>{name}</p>;
  }

  return (
    <p className={className}>
      <span
        aria-hidden="true"
        className={cn(
          "inline-block select-none blur-[5px]",
        )}
      >
        {name}
      </span>
      <span className="sr-only">{anonymousLabel}</span>
    </p>
  );
}
